import { CloudUploadIcon } from '@heroicons/react/outline';
import { useSetAtom } from 'jotai';
import {
  notificationAtom,
  NotificationType,
  pageLoadingAtom,
} from '../../atoms/system';
import { defaultAuth } from '../../atoms/auth';
import ky from 'ky';
import _ from 'lodash';
import { Header } from '../../widgets';
import { LISTURL } from '../../config';
import api from '../../api';
import { useImmer } from 'use-immer';
import clsx from 'clsx';
import Cookies from 'js-cookie';
import { COOKIENAME } from '../../config';

const breadcrumbs = [
  { name: 'Đánh giá', href: LISTURL.reviews_list, current: false },
  { name: 'Import đánh giá', href: LISTURL.reviews_list, current: true },
];

const Import = (): JSX.Element => {
  const notification = useSetAtom(notificationAtom);
  const pageLoading = useSetAtom(pageLoadingAtom);
  const [file, setFile] = useImmer<Blob | null>(null);
  const [isLock, setIsLock] = useImmer<boolean>(
    _.isUndefined(Cookies.get(`${COOKIENAME}_fileimport`)) ? false : true,
  );
  const [alert, setAlert] = useImmer<string | null>(null);

  const handleFile = async (e: any) => {
    try {
      const file = e.target.files[0];
      if (
        _.indexOf(
          [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
          ],
          file.type,
        ) === -1
      ) {
        throw Error('Định dạng không đúng');
      }
      if (file.size > 1048576) {
        throw Error('File chỉ được phép dưới 1mb');
      }
      const blob = new Blob([file], { type: file.type });
      setFile(blob);
    } catch (e: any) {
      console.log(e);
      setFile(null);
      notification({
        show: true,
        type: null,
        title: _.toString(e),
      });
    }
  };
  const handleUpload = async () => {
    try {
      pageLoading(true);
      if (_.isNull(file)) {
        throw Error();
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('folder', _.toString(defaultAuth?.insider_id));
      formData.append('upload_preset', 'gck9nbqm');
      const result = await ky
        .post('https://api.cloudinary.com/v1_1/oni/raw/upload', {
          body: formData,
        })
        .json<{ secure_url: string }>();
      await api.post('api/comments/import-review', {
        json: {
          file: result.secure_url,
        },
      });

      Cookies.set(`${COOKIENAME}_fileimport`, '', { expires: 0.01 });
      setAlert(
        'Dữ liệu của bạn đang được xử lý, quá trình này có thể mất vài phút.',
      );
      setIsLock(true);
      notification({
        show: true,
        type: NotificationType.success,
        title: 'Tải dữ liệu thành công',
      });
    } catch (e) {
      console.log(e);
      notification({
        show: true,
        type: null,
        title: null,
      });
    } finally {
      pageLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <Header title="Import đánh giá" breadcrumbs={breadcrumbs} action={null} />
      <div className="p-3 mt-3">
        <div className=" max-w-md mx-auto space-y-6 flex flex-col justify-center items-center min-h-[400px]">
          <div className="space-y-1 text-center">
            <div className="flex flex-col items-center p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50">
              <p>
                Vui lòng xem hướng dẫn cách nhập liệu file excel ở link dưới
                đây, để dữ liệu import lên đúng và đầy đủ.
              </p>
              <a
                className="text-blue-800 underline"
                target="_blank"
                href="https://docs.google.com/document/d/1c2wvX1AkVOcULgCTlFV_LOdcfaosPjewP56hKF2a-6U/edit?usp=sharing"
              >
                Hướng dẫn cách nhập liệu file excel
              </a>
            </div>
            <a
              href="https://file.hstatic.net/200000632363/file/sample_c645e52817cd4cd88885f6720f56bbc4.xlsx"
              className="text-sm font-medium text-indigo-600"
            >
              Tải file excel mẫu
            </a>
            <p className="text-xs text-gray-500">
              Những trường có dấu (*) là bắt buộc nhập.
              <br /> Lưu ý: Những dòng dữ liệu không đúng định dạng sẽ tự động
              bị bỏ qua.
            </p>
          </div>
          <div className="flex justify-center items-center w-full">
            <input
              type="file"
              id="upload-review"
              className="hidden"
              onChange={handleFile}
              accept=".xlsx,.xls,.csv"
            />
            <label
              htmlFor="upload-review"
              className="p-10 bg-gray-50 cursor-pointer flex space-y-3 flex-col justify-center items-center w-full border-2 border-gray-300 border-dashed rounded-md"
            >
              <CloudUploadIcon className="text-gray-500 w-12 h-12" />
              <span className="font-medium text-sm text-gray-700">
                Click để tải file lên
              </span>
              <p className="text-xs text-gray-500">
                Hỗ trợ định dạng .xlsx, .xls, .csv. Tối đa 500 dòng đánh giá.
              </p>
            </label>
          </div>
          <div className="space-y-2">
            {!_.isNull(alert) ? (
              <p className="text-xs text-center text-green-600">{alert}</p>
            ) : (
              <>
                {isLock ? (
                  <p className="text-xs text-center text-yellow-600">
                    Dữ liệu đang được xử lý. Vui lòng tiếp tục sử dụng chức năng
                    sau 15 phút.
                  </p>
                ) : (
                  <>
                    {_.isNull(file) ? (
                      <p className="text-xs text-center text-yellow-600">
                        Vui lòng chọn file
                      </p>
                    ) : null}
                    <button
                      onClick={handleUpload}
                      type="button"
                      className={clsx(
                        _.isNull(file)
                          ? 'pointer-events-none bg-gray-600 hover:bg-gray-700'
                          : 'bg-indigo-600 hover:bg-indigo-700',
                        'flex w-full justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
                      )}
                    >
                      Nhập dữ liệu
                    </button>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Import;
